import { useErrorSnackbar } from 'ComponentLibrary'

export function useGlobalMutationErrorHandler(onError?: (error: unknown) => void) {
    const globallyHandleError = useErrorSnackbar().handleError

    return (error: unknown) => {
        onError?.(error)
        globallyHandleError(error)
    }
}
